import cx from 'classnames'
import React from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import Icon from '../../../../../../components/Icon/Icon'
import Typography from '../../../../../../components/Typography/Typography'

import './TicketDelete.scss'

const TicketDelete = ({ className, handleYes, handleNo }) => {
    const intl = useIntl()

    return (
        <Container fluid className={cx('ticket-delete d-flex justify-content-between', className)}>
            <div className="ticket-delete--content d-flex align-items-center">
                <Icon name={'info'} />
                <Typography variant={'subtitle'}>{intl.formatMessage({ id: 'windows.notification.title' })}</Typography>
                <div className="border-end border-lighterPrimary h-100" />
                <Typography variant={'tableText'}>{intl.formatMessage({ id: 'yourOrder.throwAway' })}</Typography>
            </div>
            <div className="ticket-delete--content d-flex">
                <ButtonCinestar variant={'primary-v1'} onClick={handleYes} className={'text-uppercase'}>
                    {intl.formatMessage({ id: 'buttons.yes' })}
                </ButtonCinestar>
                <ButtonCinestar variant={'secondary'} onClick={handleNo} className={'text-uppercase'}>
                    {intl.formatMessage({ id: 'buttons.no' })}
                </ButtonCinestar>
            </div>
        </Container>
    )
}

export default TicketDelete
